import { useFeature } from "byzantine";
import { RecipientDrawer, DRAWER_TYPES } from "../../RecipientDrawer";
import { RecipientDrawer as NewRecipientDrawer } from "../../../src/modules/recipientDrawer";

interface SettingsRecipientDrawerProps {
  isOpen: boolean;
  recipientId?: API.RecipientId;
  onClose: () => void;
}

const SettingsRecipientDrawer = ({
  isOpen,
  recipientId,
  onClose,
}: SettingsRecipientDrawerProps) => {
  const isNewDrawerEnabled = useFeature().featureEnabled("recipient_drawer");

  if (isNewDrawerEnabled) {
    return (
      <NewRecipientDrawer
        isOpen={isOpen}
        flow="settings"
        onClose={onClose}
        {...(recipientId ? { mode: "edit", recipientId } : { mode: "create" })}
      />
    );
  }

  return (
    <RecipientDrawer
      isOpen={isOpen}
      handleClose={onClose}
      drawerType={recipientId ? DRAWER_TYPES.edit : DRAWER_TYPES.add}
      recipientId={recipientId}
    />
  );
};

export default SettingsRecipientDrawer;
